import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=a78dcf46&"
import script from "./LogoutPage.vue?vue&type=script&lang=js&"
export * from "./LogoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78dcf46')) {
      api.createRecord('a78dcf46', component.options)
    } else {
      api.reload('a78dcf46', component.options)
    }
    module.hot.accept("./LogoutPage.vue?vue&type=template&id=a78dcf46&", function () {
      api.rerender('a78dcf46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LogoutPage.vue"
export default component.exports